import { html } from 'rune-ts';

export const mps_arrow_down = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2166_45017)">
    <path
      d="M4 7.125C4.22 7.125 4.45 7.205 4.62 7.385L12 14.765L19.38 7.385C19.72 7.045 20.28 7.045 20.62 7.385C20.96 7.725 20.96 8.285 20.62 8.625L12.62 16.625C12.28 16.965 11.72 16.965 11.38 16.625L3.38 8.625C3.04 8.285 3.04 7.725 3.38 7.385C3.55 7.215 3.78 7.125 4 7.125Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2166_45017">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const mp_arrow_down = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path d="M21 7L12 16L3 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const ciety_arrow_down = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M18.105 8.41504L12.45 13.98L12.42 14.01C12.27 14.16 12.03 14.16 11.88 14.01L6.32997 8.53504L6.20997 8.41504L5.15997 9.46504L10.845 15.045C11.205 15.405 11.685 15.585 12.165 15.585C12.645 15.585 13.125 15.405 13.485 15.045L19.035 9.58504L19.17 9.45004L18.105 8.41504Z"
    fill="#B1B1B1"
  />
</svg>`;

export const mps_arrow_up = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2166_45018)">
    <path
      d="M20 16.88C19.78 16.88 19.55 16.8 19.38 16.62L12 9.24L4.62 16.62C4.28 16.96 3.72 16.96 3.38 16.62C3.04 16.28 3.04 15.72 3.38 15.38L11.38 7.38C11.72 7.04 12.28 7.04 12.62 7.38L20.62 15.38C20.96 15.72 20.96 16.28 20.62 16.62C20.45 16.79 20.22 16.88 20 16.88Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2166_45018">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const mp_arrow_up = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path d="M3 17L12 8L21 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const ciety_arrow_up = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M6.22517 15.585L11.8802 10.02L11.9102 9.98996C12.0602 9.83996 12.3002 9.83996 12.4502 9.98996L18.0002 15.465L18.1202 15.585L19.1702 14.535L13.4852 8.95496C13.1252 8.59496 12.6452 8.41496 12.1652 8.41496C11.6852 8.41496 11.2052 8.59496 10.8452 8.95496L5.29517 14.415L5.16017 14.55L6.22517 15.585Z"
    fill="#B1B1B1"
  />
</svg>`;

export const mps_arrow_left = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2338_43579)">
    <path
      d="M11.88 20.88C11.66 20.88 11.43 20.79 11.26 20.62L3.26 12.62C3.18 12.54 3.11 12.44 3.07 12.33C3.03 12.23 3.01 12.13 3 12.02V11.99C3 11.88 3.03 11.77 3.07 11.68C3.11 11.57 3.18 11.48 3.26 11.39L11.26 3.38C11.6 3.04 12.16 3.04 12.5 3.38C12.84 3.72 12.84 4.28 12.5 4.62L5.99 11.13H20.13C20.61 11.13 21.01 11.52 21.01 12.01C21.01 12.5 20.62 12.89 20.13 12.89H5.99L12.5 19.4C12.84 19.74 12.84 20.3 12.5 20.64C12.33 20.81 12.1 20.9 11.88 20.9V20.88Z"
      fill="#141414"
    />
  </g>
</svg>`;

export const ciety_arrow_left = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M14.94 21L7.66 13.59C6.78 12.71 6.78 11.29 7.66 10.41L14.94 3L16 4.06L8.72 11.47C8.43 11.76 8.43 12.24 8.72 12.53L16 19.94L14.94 21Z"
    fill="#B1B1B1"
  />
</svg>`;

export const mp_arrow_left = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path d="M17 21L8 12L17 3" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const mps_close = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M13.2583 12.0001L20.7379 4.51006C21.0874 4.16006 21.0874 3.60006 20.7379 3.26006C20.3884 2.91006 19.8291 2.91006 19.4796 3.26006L12 10.7401L4.52039 3.26006C4.17087 2.91006 3.61165 2.91006 3.26214 3.26006C2.91262 3.61006 2.91262 4.17006 3.26214 4.51006L10.7417 12.0001L3.26214 19.4901C2.91262 19.8401 2.91262 20.4001 3.26214 20.7401C3.4319 20.9101 3.66158 21.0001 3.89126 21.0001C4.12094 21.0001 4.34064 20.9101 4.52039 20.7401L12 13.2601L19.4796 20.7401C19.6494 20.9101 19.8791 21.0001 20.1087 21.0001C20.3384 21.0001 20.5581 20.9101 20.7379 20.7401C21.0874 20.3901 21.0874 19.8301 20.7379 19.4901L13.2583 12.0001Z"
    fill="currentColor"
  />
</svg>`;

export const ciety_close = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M22 3.06L20.94 2L14.12 8.82C12.95 9.99 11.05 9.99 9.88 8.82L3.06 2L2 3.06L8.82 9.88C9.99 11.05 9.99 12.95 8.82 14.12L2 20.94L3.06 22L9.88 15.18C11.05 14.01 12.95 14.01 14.12 15.18L20.94 22L22 20.94L15.18 14.12C14.01 12.95 14.01 11.05 15.18 9.88L22 3.06Z"
    fill="#77777C"
  />
</svg>`;

export const mp_close = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M3 2.99951L21 20.9995M3 20.9995L21 2.99951"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;

export const mps_remove = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 16 16">
  <rect width="100%" height="100%" fill="currentColor" rx="8" />
  <g clip-path="url(#mps_remove)">
    <path
      fill="#fff"
      d="m8.524 8 3.117-3.12a.365.365 0 0 0 0-.522.369.369 0 0 0-.524 0L8 7.475 4.883 4.358a.369.369 0 0 0-.524 0 .365.365 0 0 0 0 .521L7.476 8l-3.117 3.12a.365.365 0 0 0 0 .522.371.371 0 0 0 .524 0L8 8.525l3.117 3.117a.371.371 0 0 0 .524 0 .365.365 0 0 0 0-.521L8.524 8Z"
    />
  </g>
  <defs>
    <clipPath id="mps_remove">
      <path fill="#fff" d="M3 3h10v10H3z" />
    </clipPath>
  </defs>
</svg>`;

export const mp_remove = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 16 16">
  <rect width="100%" height="100%" fill="currentColor" rx="8" />
  <g clip-path="url(#mp_remove)">
    <path
      fill="#fff"
      d="m8.524 8 3.117-3.12a.365.365 0 0 0 0-.522.369.369 0 0 0-.524 0L8 7.475 4.883 4.358a.369.369 0 0 0-.524 0 .365.365 0 0 0 0 .521L7.476 8l-3.117 3.12a.365.365 0 0 0 0 .522.371.371 0 0 0 .524 0L8 8.525l3.117 3.117a.371.371 0 0 0 .524 0 .365.365 0 0 0 0-.521L8.524 8Z"
    />
  </g>
  <defs>
    <clipPath id="mp_remove">
      <path fill="#fff" d="M3 3h10v10H3z" />
    </clipPath>
  </defs>
</svg> `;

export const ciety_remove = html`<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
  <path
    d="M7.99992 1.3335C4.31992 1.3335 1.33325 4.3135 1.33325 8.00016C1.33325 11.6868 4.31992 14.6668 7.99992 14.6668C11.6799 14.6668 14.6666 11.6868 14.6666 8.00016C14.6666 4.3135 11.6866 1.3335 7.99992 1.3335ZM9.17992 8.4735L11.0199 10.3135L10.3133 11.0202L8.47325 9.18016C8.21325 8.92016 7.79325 8.92016 7.53325 9.18016L5.69325 11.0202L4.98659 10.3135L6.82659 8.4735C7.08659 8.2135 7.08659 7.7935 6.82659 7.5335L4.98659 5.6935L5.69325 4.98683L7.53325 6.82683C7.79325 7.08683 8.21325 7.08683 8.47325 6.82683L10.3133 4.98683L11.0199 5.6935L9.17992 7.5335C8.91992 7.7935 8.91992 8.2135 9.17992 8.4735Z"
    fill="#77777C"
  />
</svg>`;

export const mps_visible = html` <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
  <path
    d="M15.8688 7.7465C15.8451 7.68317 15.283 6.19484 14.048 4.7065C12.3934 2.71942 10.3034 1.6665 7.99967 1.6665C5.69592 1.6665 3.60592 2.71942 1.95134 4.7065C0.708424 6.19484 0.146341 7.68317 0.130508 7.7465C0.0988411 7.82567 0.0830078 7.91275 0.0830078 7.99984C0.0830078 8.08692 0.0988411 8.174 0.130508 8.25317C0.154258 8.3165 0.716341 9.80484 1.95134 11.2932C3.60592 13.2803 5.69592 14.3253 7.99967 14.3253C10.3034 14.3253 12.3934 13.2723 14.048 11.2932C15.2909 9.80484 15.8451 8.3165 15.8688 8.25317C15.9005 8.174 15.9163 8.08692 15.9163 7.99984C15.9163 7.91275 15.9005 7.82567 15.8688 7.7465ZM7.99967 11.1665C6.25009 11.1665 4.83301 9.74942 4.83301 7.99984C4.83301 6.25025 6.25009 4.83317 7.99967 4.83317C9.74926 4.83317 11.1663 6.25025 11.1663 7.99984C11.1663 9.74942 9.74926 11.1665 7.99967 11.1665Z"
    fill="currentColor"
  />
  <path
    d="M7.99967 10.3748C9.31135 10.3748 10.3747 9.31151 10.3747 7.99984C10.3747 6.68816 9.31135 5.62484 7.99967 5.62484C6.688 5.62484 5.62467 6.68816 5.62467 7.99984C5.62467 9.31151 6.688 10.3748 7.99967 10.3748Z"
    fill="currentColor"
  />
</svg>`;

export const ciety_visible = html` <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_6065_14975)">
    <path
      d="M15.7399 7.16754C15.5665 6.82797 15.313 6.4551 14.9796 6.0556C14.6461 5.6561 14.2459 5.2566 13.7724 4.8571C13.2989 4.4576 12.7653 4.09805 12.1717 3.76513C11.5782 3.43221 10.9312 3.17254 10.2309 2.96613C9.53064 2.76638 8.79033 2.6665 8.00333 2.6665C7.21634 2.6665 6.4827 2.76638 5.78908 2.96613C5.09546 3.16588 4.44852 3.43221 3.85494 3.76513C3.26136 4.09805 2.7278 4.4576 2.25427 4.8571C1.78074 5.2566 1.37391 5.6561 1.04043 6.0556C0.706961 6.4551 0.446853 6.82797 0.266778 7.16754C0.0867028 7.50712 0 7.78677 0 7.99984C0 8.2129 0.0867028 8.49255 0.260108 8.83213C0.433514 9.17171 0.686953 9.54457 1.02043 9.94407C1.3539 10.3436 1.75406 10.7431 2.22759 11.1426C2.70113 11.5421 3.23468 11.9016 3.82826 12.2345C4.42184 12.5675 5.06878 12.8271 5.76907 13.0335C6.46936 13.2333 7.20967 13.3332 7.99667 13.3332C8.78366 13.3332 9.5173 13.2333 10.2109 13.0335C10.9045 12.8338 11.5515 12.5675 12.1451 12.2345C12.7386 11.9016 13.2722 11.5421 13.7457 11.1426C14.2193 10.7431 14.6261 10.3436 14.9596 9.94407C15.293 9.54457 15.5531 9.17171 15.7332 8.83213C15.9133 8.49255 16 8.2129 16 7.99984C16 7.78677 15.9133 7.50712 15.7399 7.16754ZM7.99667 11.1293C6.1559 11.1293 4.66194 9.63779 4.66194 7.80009C4.66194 5.96238 6.1559 4.47092 7.99667 4.47092C9.83743 4.47092 11.3314 5.96238 11.3314 7.80009C11.3314 9.63779 9.83743 11.1293 7.99667 11.1293Z"
      fill="#77777C"
    />
    <path
      d="M7.99667 9.80425C9.1017 9.80425 9.9975 8.90994 9.9975 7.80675C9.9975 6.70356 9.1017 5.80924 7.99667 5.80924C6.89164 5.80924 5.99583 6.70356 5.99583 7.80675C5.99583 8.90994 6.89164 9.80425 7.99667 9.80425Z"
      fill="#77777C"
    />
  </g>
  <defs>
    <clipPath id="clip0_6065_14975">
      <rect width="100%" height="100%" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const mp_visible = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.571 8c0 1.767 1.535 3.2 3.429 3.2 1.893 0 3.428-1.433 3.428-3.2 0-1.767-1.535-3.2-3.428-3.2-1.894 0-3.43 1.433-3.43 3.2ZM8 2.667c3.084 0 5.812 1.51 7.518 3.838a2.558 2.558 0 0 1 0 2.99c-1.706 2.327-4.434 3.838-7.518 3.838-3.084 0-5.812-1.51-7.518-3.839a2.556 2.556 0 0 1 0-2.989C2.188 4.178 4.916 2.667 8 2.667ZM6.667 8a1.333 1.333 0 1 1 2.665-.001 1.333 1.333 0 0 1-2.665 0Z"
    clip-rule="evenodd"
  />
</svg> `;

export const mps_hide = html`<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
  <path
    d="M2.90134 1.91984C2.63217 1.65067 2.18884 1.65067 1.91967 1.91984C1.65051 2.189 1.65051 2.63234 1.91967 2.9015L2.81426 3.79609C2.51342 4.07317 2.22842 4.374 1.95134 4.7065C0.708425 6.19484 0.146341 7.68317 0.130508 7.7465C0.0988411 7.82567 0.0830078 7.91275 0.0830078 7.99984C0.0830078 8.08692 0.0988411 8.174 0.130508 8.25317C0.154258 8.3165 0.716341 9.80484 1.95134 11.2932C3.60592 13.2803 5.69592 14.3253 7.99967 14.3253C9.47217 14.3253 10.8497 13.8898 12.0847 13.0586L13.098 14.0719C13.2326 14.2065 13.4068 14.2778 13.5888 14.2778C13.7709 14.2778 13.9451 14.2144 14.0797 14.0719C14.3488 13.8028 14.3488 13.3594 14.0797 13.0903L2.90134 1.91984ZM7.99967 11.1665C6.25009 11.1665 4.83301 9.74942 4.83301 7.99984C4.83301 7.37442 5.02301 6.7965 5.33176 6.31359L5.90967 6.8915C5.72759 7.224 5.62467 7.59609 5.62467 7.99984C5.62467 9.314 6.68551 10.3748 7.99967 10.3748C8.40343 10.3748 8.77551 10.2719 9.10801 10.0898L9.68592 10.6678C9.19509 10.9765 8.61718 11.1665 7.99967 11.1665Z"
    fill="currentColor"
  />
  <path
    d="M15.8688 7.7465C15.8451 7.68317 15.283 6.19484 14.048 4.7065C12.3934 2.71942 10.3034 1.6665 7.99967 1.6665C7.01009 1.6665 6.06009 1.87234 5.16551 2.25234L14.1193 11.2061C15.3068 9.74942 15.8451 8.32442 15.8688 8.26109C15.9005 8.18192 15.9163 8.09484 15.9163 8.00775C15.9163 7.92067 15.9005 7.83359 15.8688 7.75442V7.7465Z"
    fill="currentColor"
  />
</svg>`;

export const mp_hide = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.087.264a.571.571 0 0 0-.805.066l-2.377 2.803A9.228 9.228 0 0 0 8 2.667c-3.084 0-5.812 1.51-7.518 3.838a2.556 2.556 0 0 0 0 2.99 9.464 9.464 0 0 0 2.845 2.572L1.593 14.11a.571.571 0 1 0 .872.739L14.152 1.07a.571.571 0 0 0-.066-.806Zm-8.883 9.59 4.087-4.82A3.633 3.633 0 0 0 8 4.8C6.106 4.8 4.57 6.233 4.57 8c0 .69.235 1.33.633 1.853ZM8 11.2a3.63 3.63 0 0 1-1.31-.242l-1.638 1.895c.926.312 1.917.48 2.948.48 3.084 0 5.812-1.51 7.518-3.839a2.556 2.556 0 0 0 0-2.989 9.466 9.466 0 0 0-2.785-2.537L10.82 6.18A3.04 3.04 0 0 1 11.428 8c0 1.767-1.535 3.2-3.428 3.2Z"
    clip-rule="evenodd"
  />
</svg> `;

export const ciety_hide = html`<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
  <path
    d="M12.64 11.9335L2.04 1.3335L1.33333 2.04016L3.36 4.06683C2.96667 4.3135 2.58667 4.5735 2.25333 4.8535C1.78 5.2535 1.37333 5.6535 1.04 6.0535C0.706667 6.4535 0.446667 6.82683 0.266667 7.16683C0.0866667 7.50683 0 7.78683 0 8.00016C0 8.2135 0.0866667 8.4935 0.26 8.8335C0.433333 9.1735 0.686667 9.54683 1.02 9.94683C1.35333 10.3468 1.75333 10.7468 2.22667 11.1468C2.7 11.5468 3.23333 11.9068 3.82667 12.2402C4.42 12.5735 5.06667 12.8335 5.76667 13.0402C6.46667 13.2402 7.20667 13.3402 7.99333 13.3402C8.78 13.3402 9.51333 13.2402 10.2067 13.0402C10.7467 12.8868 11.2467 12.6802 11.7267 12.4468L13.96 14.6802L14.6667 13.9735L12.64 11.9468V11.9335ZM8 11.1402C6.16 11.1402 4.66667 9.64683 4.66667 7.80683C4.66667 7.12016 4.87333 6.4735 5.23333 5.94683L5.96667 6.68016C5.78 7.0135 5.66667 7.3935 5.66667 7.80683C5.66667 9.0935 6.71333 10.1402 8 10.1402C8.41333 10.1402 8.79333 10.0268 9.12667 9.84016L9.86 10.5735C9.32667 10.9335 8.68667 11.1402 8 11.1402Z"
    fill="#77777C"
  />
  <path
    d="M15.74 7.16683C15.5667 6.82683 15.3133 6.4535 14.98 6.0535C14.6467 5.6535 14.2467 5.2535 13.7733 4.8535C13.3 4.4535 12.7667 4.0935 12.1733 3.76016C11.58 3.42683 10.9333 3.16683 10.2333 2.96016C9.53333 2.76016 8.79333 2.66016 8.00667 2.66016C7.22 2.66016 6.48667 2.76016 5.79333 2.96016C5.61333 3.0135 5.44667 3.08016 5.27333 3.14016L6.82 4.68683C7.18667 4.54683 7.58667 4.46016 8 4.46016C9.84 4.46016 11.3333 5.9535 11.3333 7.7935C11.3333 8.2135 11.2467 8.60683 11.1067 8.9735L13.4733 11.3402C13.5667 11.2668 13.66 11.2068 13.7467 11.1335C14.22 10.7335 14.6267 10.3335 14.96 9.9335C15.2933 9.5335 15.5533 9.16016 15.7333 8.82016C15.9133 8.48016 16 8.20016 16 7.98683C16 7.7735 15.9133 7.4935 15.74 7.1535V7.16683Z"
    fill="#77777C"
  />
  <path
    d="M10.3333 7.80683C10.3333 6.52016 9.28667 5.4735 8 5.4735C7.87333 5.4735 7.75333 5.4935 7.62667 5.5135L10.2933 8.18016C10.3133 8.06016 10.3333 7.9335 10.3333 7.80683Z"
    fill="#77777C"
  />
</svg>`;

export const mps_check = html`
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
    <path
      d="M3.87277 7.17479C3.53088 6.8329 2.97656 6.8329 2.63467 7.17479C2.29278 7.51668 2.29278 8.071 2.63467 8.41289L5.98754 11.7658C6.30091 12.0791 6.809 12.0791 7.12237 11.7658L13.3645 5.52365C13.7064 5.18176 13.7064 4.62744 13.3645 4.28555C13.0226 3.94366 12.4683 3.94366 12.1264 4.28555L6.96761 9.44432C6.73971 9.67223 6.3702 9.67223 6.1423 9.44433L3.87277 7.17479Z"
      fill="currentColor"
    />
  </svg>
`;

export const mp_check = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 16 16">
  <path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    d="m14 4-7.333 6.667-4.667-4"
  />
</svg> `;

export const ciety_check = html`
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
    <path
      d="M6.87333 11.3332C6.38667 11.3332 5.92667 11.1511 5.58 10.831L2 7.45998L2.70667 6.79456L6.28667 10.1656C6.6 10.4606 7.14667 10.4606 7.46 10.1656L13.2933 4.6665L14 5.33192L8.16 10.831C7.81333 11.1574 7.35333 11.3332 6.86667 11.3332H6.87333Z"
      fill="currentColor"
    />
  </svg>
`;

export const mps_info = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#mps_info)">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z"
      fill="#1C75FF"
    />
  </g>
  <defs>
    <clipPath id="mps_info">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const ciety_info = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 11.999C2 6.46902 6.47 1.99902 12 1.99902C17.52 1.99902 22 6.46902 22 11.999C22 17.529 17.53 21.999 12 21.999C6.47 21.999 2 17.529 2 11.999ZM13 9.99902L13 16.999H11L11 9.99902H13ZM11 7.99902C11 7.44674 11.4477 6.99902 12 6.99902C12.5523 6.99902 13 7.44674 13 7.99902C13 8.55131 12.5523 8.99902 12 8.99902C11.4477 8.99902 11 8.55131 11 7.99902Z"
    fill="#B2FF00"
  />
</svg>`;

export const ciety_info_color = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 11.999C2 6.46902 6.47 1.99902 12 1.99902C17.52 1.99902 22 6.46902 22 11.999C22 17.529 17.53 21.999 12 21.999C6.47 21.999 2 17.529 2 11.999ZM13 9.99902L13 16.999H11L11 9.99902H13ZM11 7.99902C11 7.44674 11.4477 6.99902 12 6.99902C12.5523 6.99902 13 7.44674 13 7.99902C13 8.55131 12.5523 8.99902 12 8.99902C11.4477 8.99902 11 8.55131 11 7.99902Z"
    fill="currentColor"
  />
</svg>`;

export const mp_info = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.9998 22.1998C17.6331 22.1998 22.1998 17.6331 22.1998 11.9998C22.1998 6.3665 17.6331 1.7998 11.9998 1.7998C6.3665 1.7998 1.7998 6.3665 1.7998 11.9998C1.7998 17.6331 6.3665 22.1998 11.9998 22.1998ZM12.7521 17.2943V9.6584H11.2475V17.2943H12.7521ZM11.5217 8.35762C11.667 8.4373 11.824 8.47715 11.9928 8.47715C12.1662 8.47715 12.3256 8.43965 12.4709 8.36465C12.6162 8.28496 12.7311 8.17715 12.8154 8.04121C12.9045 7.90527 12.949 7.75527 12.949 7.59121C12.949 7.43184 12.9068 7.28418 12.8225 7.14824C12.7381 7.0123 12.6232 6.90449 12.4779 6.8248C12.3326 6.74512 12.1756 6.70527 12.0068 6.70527C11.8381 6.70527 11.6787 6.74512 11.5287 6.8248C11.3834 6.90449 11.2662 7.0123 11.1771 7.14824C11.0928 7.28418 11.0506 7.43184 11.0506 7.59121C11.0506 7.75059 11.0928 7.89824 11.1771 8.03418C11.2662 8.17012 11.3811 8.27793 11.5217 8.35762Z"
    fill="#FF6B00"
  />
</svg>`;

export const mps_info_color = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#mps_info_color)">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="mps_info_color">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const mp_info_color = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.9998 22.1998C17.6331 22.1998 22.1998 17.6331 22.1998 11.9998C22.1998 6.3665 17.6331 1.7998 11.9998 1.7998C6.3665 1.7998 1.7998 6.3665 1.7998 11.9998C1.7998 17.6331 6.3665 22.1998 11.9998 22.1998ZM12.7521 17.2943V9.6584H11.2475V17.2943H12.7521ZM11.5217 8.35762C11.667 8.4373 11.824 8.47715 11.9928 8.47715C12.1662 8.47715 12.3256 8.43965 12.4709 8.36465C12.6162 8.28496 12.7311 8.17715 12.8154 8.04121C12.9045 7.90527 12.949 7.75527 12.949 7.59121C12.949 7.43184 12.9068 7.28418 12.8225 7.14824C12.7381 7.0123 12.6232 6.90449 12.4779 6.8248C12.3326 6.74512 12.1756 6.70527 12.0068 6.70527C11.8381 6.70527 11.6787 6.74512 11.5287 6.8248C11.3834 6.90449 11.2662 7.0123 11.1771 7.14824C11.0928 7.28418 11.0506 7.43184 11.0506 7.59121C11.0506 7.75059 11.0928 7.89824 11.1771 8.03418C11.2662 8.17012 11.3811 8.27793 11.5217 8.35762Z"
    fill="currentColor"
  />
</svg>`;

export const mp_pin = html`<svg width="9" height="6" viewBox="0 0 9 6" fill="none">
  <path d="M4.5 0L0.5 6H8.5L4.5 0Z" fill="#FF6B00" />
</svg> `;

export const mps_pin = html`<svg width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M7.3 0.327273L12.5 6H0.5L5.7 0.327273C6.1 -0.109091 6.9 -0.109091 7.3 0.327273Z" fill="#EBF3FE" />
</svg>`;

export const ciety_pin = html`<svg width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M7.3 0.327273L12.5 6H0.5L5.7 0.327273C6.1 -0.109091 6.9 -0.109091 7.3 0.327273Z" fill="#B2FF00" />
</svg>`;

export const mps_unlink = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2166_45019)">
    <path
      d="M11.2899 5.28C12.2799 4.29 13.5899 3.75 14.9899 3.75C16.3899 3.75 17.6999 4.29 18.6899 5.28L18.7299 5.32C20.7699 7.36 20.7699 10.68 18.7299 12.71C18.3899 13.05 18.3899 13.61 18.7299 13.95C19.0699 14.29 19.6299 14.29 19.9699 13.95C22.6999 11.22 22.6999 6.8 19.9699 4.08L19.9299 4.04C18.5699 2.68 16.7799 2 14.9899 2C13.1999 2 11.4199 2.68 10.0499 4.04C9.70992 4.38 9.70992 4.94 10.0499 5.28C10.3899 5.62 10.9499 5.62 11.2899 5.28Z"
      fill="currentColor"
    />
    <path
      d="M12.7099 18.72C11.7199 19.71 10.4099 20.25 9.00992 20.25C7.60992 20.25 6.29992 19.71 5.30992 18.72L5.26992 18.68C3.22992 16.64 3.22992 13.32 5.26992 11.29C5.60992 10.95 5.60992 10.39 5.26992 10.05C4.92992 9.71 4.36992 9.71 4.02992 10.05C1.29992 12.78 1.29992 17.2 4.02992 19.92L4.06992 19.96C5.42992 21.32 7.21992 22 9.00992 22C10.7999 22 12.5799 21.32 13.9499 19.96C14.2899 19.62 14.2899 19.06 13.9499 18.72C13.6099 18.38 13.0499 18.38 12.7099 18.72Z"
      fill="currentColor"
    />
    <path
      d="M4.59992 3.38C4.25992 3.04 3.69992 3.04 3.35992 3.38C3.01992 3.72 3.01992 4.28 3.35992 4.62L19.3699 20.63C19.5399 20.8 19.7599 20.89 19.9899 20.89C20.2199 20.89 20.4399 20.8 20.6099 20.63C20.9499 20.29 20.9499 19.73 20.6099 19.39L4.59992 3.38Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2166_45019">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const ciety_unlink = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.79106 8.85106C7.41339 9.58622 7.21532 10.3883 7.1924 11.1904C7.17241 11.8201 7.26237 12.4398 7.46227 13.0395C7.72214 13.8291 8.16192 14.5787 8.7916 15.2084C9.42129 15.8381 10.1709 16.2779 10.9605 16.5377L12.2299 15.2684C11.3603 15.1784 10.5207 14.8086 9.85107 14.1489C9.1914 13.4893 8.82159 12.6397 8.73163 11.7701C8.66906 11.1722 8.73222 10.5647 8.93455 9.99455L14.2767 15.3367C14.2358 15.3819 14.1933 15.4258 14.1489 15.4683L10.2809 19.3363C8.73163 20.8856 6.21289 20.8856 4.66367 19.3363C3.11444 17.7871 3.11444 15.2684 4.66367 13.7191L5.8031 12.5797C5.68316 11.9 5.66317 11.2004 5.74313 10.5207L3.6042 12.6597C1.46527 14.7986 1.46527 18.2569 3.6042 20.3958C5.74313 22.5347 9.2014 22.5347 11.3403 20.3958L15.2084 16.5277C15.2515 16.4847 15.2938 16.4404 15.3353 16.3953L16.44 17.5L17.92 19L20.94 22.02L22 20.96L18.96 17.9L3.06 2L2 3.06L4.97348 6.03348L6.05097 7.11097L7.79106 8.85106ZM9.66193 6.60193L10.7214 7.6614L13.7191 4.66367C15.2684 3.11444 17.7871 3.11444 19.3363 4.66367C20.8856 6.21289 20.8856 8.73163 19.3363 10.2809L18.1969 11.4203C18.3168 12.0999 18.3368 12.7996 18.2569 13.4793L20.3958 11.3403C22.5347 9.2014 22.5347 5.74313 20.3958 3.6042C18.2569 1.46527 14.7986 1.46527 12.6597 3.6042L9.66193 6.60193ZM11.7809 8.72087L11.7942 8.7342C12.6552 8.82844 13.4854 9.1975 14.1489 9.85107C14.8025 10.5047 15.1716 11.3446 15.2658 12.2058L16.7174 13.6574C16.7695 13.3768 16.7995 13.0932 16.8076 12.8096C16.8276 12.1799 16.7376 11.5602 16.5377 10.9605C16.2779 10.1709 15.8381 9.42129 15.2084 8.7916C14.5787 8.16192 13.8291 7.72214 13.0395 7.46227L11.7809 8.72087Z"
    fill="#B1B1B1"
  />
</svg>`;

export const mp_unlink = html`<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M12.041 5.48009L13.6539 3.78842C15.4937 1.91387 18.4181 1.94068 20.2267 3.84867C22.0353 5.75667 22.0607 8.84178 20.2838 10.7826L18.8772 12.2666"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.95 18.5199L10.3465 20.2115C8.50669 22.0861 5.5823 22.0593 3.77369 20.1513C1.96509 18.2433 1.93967 15.1582 3.71658 13.2173L5.1232 11.7334"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M6.59961 6.6001L17.3996 17.4001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
</svg>`;

export const mps_outlink = html` <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2166_45020)">
    <path
      d="M17.13 13.12C16.65 13.12 16.25 13.51 16.25 14V20.25H3.75V7.75H10C10.48 7.75 10.88 7.36 10.88 6.87C10.88 6.38 10.49 5.99 10 5.99H3.7C2.76 5.99 2 6.75 2 7.69V20.29C2 21.23 2.76 21.99 3.7 21.99H16.3C17.24 21.99 18 21.23 18 20.29V13.99C18 13.51 17.61 13.11 17.12 13.11L17.13 13.12Z"
      fill="currentColor"
    />
    <path
      d="M21.93 2.54C21.84 2.33 21.67 2.16 21.46 2.07C21.35 2.03 21.24 2 21.13 2H12.63C12.15 2 11.75 2.39 11.75 2.88C11.75 3.37 12.14 3.76 12.63 3.76H19.02L12.01 10.77C11.67 11.11 11.67 11.67 12.01 12.01C12.18 12.18 12.4 12.27 12.63 12.27C12.86 12.27 13.08 12.18 13.25 12.01L20.26 5V11.39C20.26 11.87 20.65 12.27 21.14 12.27C21.63 12.27 22.02 11.88 22.02 11.39V2.88C22.02 2.77 22 2.65 21.95 2.55L21.93 2.54Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2166_45020">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const ciety_outlink = html` <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
  <path
    d="M4.7 2H8V3.5H4.7C4.04 3.5 3.5 4.04 3.5 4.7V19.3C3.5 19.96 4.04 20.5 4.7 20.5H19.3C19.96 20.5 20.5 19.96 20.5 19.3V16H22V19.3C22 20.79 20.79 22 19.3 22H4.7C3.21 22 2 20.79 2 19.3V4.7C2 3.21 3.21 2 4.7 2Z"
    fill="currentColor"
  />
  <path
    d="M20.5 4.7C20.5 4.7 20.48 4.62 20.48 4.58L10.46 14.6L9.4 13.54L19.42 3.52C19.42 3.52 19.35 3.5 19.3 3.5H13V2H19.3C20.79 2 22 3.21 22 4.7V11H20.5V4.7Z"
    fill="currentColor"
  />
</svg>`;

export const mp_outlink = html`<svg width="1em" height="1em" viewBox="0 0 28 28" fill="none">
  <path
    d="M12.1471 5H7C5.89543 5 5 5.89543 5 7V21C5 22.1046 5.89543 23 7 23H21C22.1046 23 23 22.1046 23 21V16.1176"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path d="M17 5H23V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M23 5L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const mp_round_unlink = html`<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none">
  <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="black" />
  <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="white" />
  <path
    d="M9.01953 5.74029L9.82599 4.89445C10.7459 3.95718 12.2081 3.97058 13.1124 4.92458C14.0167 5.87858 14.0294 7.42113 13.1409 8.39157L12.4376 9.13353"
    stroke="white"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.97403 12.2599L8.17225 13.1058C7.25237 14.043 5.79017 14.0296 4.88587 13.0756C3.98157 12.1216 3.96886 10.5791 4.85731 9.60866L5.56062 8.8667"
    stroke="white"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M6.30078 6.2998L11.7008 11.6998" stroke="white" stroke-linecap="round" />
</svg> `;

export const mps_round_unlink = html`<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none">
  <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#141414" />
  <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="white" />
  <g clip-path="url(#unlink_icon_marppleshop)">
    <path
      d="M8.64594 5.64C9.14094 5.145 9.79594 4.875 10.4959 4.875C11.1959 4.875 11.8509 5.145 12.3459 5.64L12.3659 5.66C13.3859 6.68 13.3859 8.34 12.3659 9.355C12.1959 9.525 12.1959 9.805 12.3659 9.975C12.5359 10.145 12.8159 10.145 12.9859 9.975C14.3509 8.61 14.3509 6.4 12.9859 5.04L12.9659 5.02C12.2859 4.34 11.3909 4 10.4959 4C9.60094 4 8.71094 4.34 8.02594 5.02C7.85594 5.19 7.85594 5.47 8.02594 5.64C8.19594 5.81 8.47594 5.81 8.64594 5.64Z"
      fill="white"
    />
    <path
      d="M9.35594 12.36C8.86094 12.855 8.20594 13.125 7.50594 13.125C6.80594 13.125 6.15094 12.855 5.65594 12.36L5.63594 12.34C4.61594 11.32 4.61594 9.66 5.63594 8.645C5.80594 8.475 5.80594 8.195 5.63594 8.025C5.46594 7.855 5.18594 7.855 5.01594 8.025C3.65094 9.39 3.65094 11.6 5.01594 12.96L5.03594 12.98C5.71594 13.66 6.61094 14 7.50594 14C8.40094 14 9.29094 13.66 9.97594 12.98C10.1459 12.81 10.1459 12.53 9.97594 12.36C9.80594 12.19 9.52594 12.19 9.35594 12.36Z"
      fill="white"
    />
    <path
      d="M5.30094 4.69C5.13094 4.52 4.85094 4.52 4.68094 4.69C4.51094 4.86 4.51094 5.14 4.68094 5.31L12.6859 13.315C12.7709 13.4 12.8809 13.445 12.9959 13.445C13.1109 13.445 13.2209 13.4 13.3059 13.315C13.4759 13.145 13.4759 12.865 13.3059 12.695L5.30094 4.69Z"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="unlink_icon_marppleshop">
      <rect width="12" height="12" fill="white" transform="translate(3 3)" />
    </clipPath>
  </defs>
</svg> `;

export const ciety_round_unlink = html`<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none">
  <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#FBFBFB" />
  <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#13131A" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.89553 7.42553C6.70669 7.79311 6.60766 8.19416 6.5962 8.5952C6.58621 8.91004 6.63118 9.21989 6.73113 9.51974C6.86107 9.91454 7.08096 10.2894 7.3958 10.6042C7.71064 10.919 8.08546 11.1389 8.48026 11.2689L9.11494 10.6342C8.68016 10.5892 8.26037 10.4043 7.92554 10.0745C7.5957 9.74463 7.41079 9.31984 7.36582 8.88506C7.33453 8.58612 7.36611 8.28234 7.46728 7.99728L10.1384 10.6684C10.1179 10.6909 10.0967 10.7129 10.0745 10.7341L8.14043 12.6682C7.36582 13.4428 6.10645 13.4428 5.33183 12.6682C4.55722 11.8936 4.55722 10.6342 5.33183 9.85957L5.90155 9.28986C5.84158 8.95003 5.83158 8.6002 5.87156 8.26037L4.8021 9.32983C3.73263 10.3993 3.73263 12.1284 4.8021 13.1979C5.87156 14.2674 7.6007 14.2674 8.67017 13.1979L10.6042 11.2639C10.6257 11.2423 10.6469 11.2202 10.6677 11.1977L11.22 11.75L11.96 12.5L13.47 14.01L14 13.48L12.48 11.95L4.53 4L4 4.53L5.48674 6.01674L6.02549 6.55549L6.89553 7.42553ZM7.83097 6.30097L8.3607 6.8307L9.85957 5.33183C10.6342 4.55722 11.8936 4.55722 12.6682 5.33183C13.4428 6.10645 13.4428 7.36582 12.6682 8.14043L12.0985 8.71014C12.1584 9.04997 12.1684 9.3998 12.1284 9.73963L13.1979 8.67017C14.2674 7.6007 14.2674 5.87156 13.1979 4.8021C12.1284 3.73263 10.3993 3.73263 9.32983 4.8021L7.83097 6.30097ZM8.89044 7.36044L8.8971 7.3671C9.32759 7.41422 9.74272 7.59875 10.0745 7.92554C10.4013 8.25233 10.5858 8.67232 10.6329 9.1029L11.3587 9.8287C11.3847 9.68839 11.3997 9.54659 11.4038 9.4048C11.4138 9.08996 11.3688 8.78011 11.2689 8.48026C11.1389 8.08546 10.919 7.71064 10.6042 7.3958C10.2894 7.08096 9.91454 6.86107 9.51974 6.73113L8.89044 7.36044Z"
    fill="#13131A"
  />
</svg> `;
